<template>
  <div class="email-task-wrapper">
    <div class="modal task">
      <div class="modal-close" @click="close"></div>
      <div class="custom-modal-header">Email senden</div>
      <div class="content">
        <div
          class="tools"
          :style="{
            top: toolsTop,
          }"
        >
          <div class="element" v-if="files.length > 0 && isUserHasAccess">
            <div class="button" @click.stop="toggleAttacheFile">
              <svg
                width="18px"
                height="18px"
                x="0px"
                y="0px"
                viewBox="0 0 607.983 607.983"
              >
                <g>
                  <g>
                    <path
                      d="M112.682,572.01c23.18,23.198,56.648,35.974,94.234,35.974c46.082,0,92.125-18.541,123.161-49.61L581.403,307.09
                        c0,0,6.152-6.942,6.152-16.92c0-13.517-10.957-24.471-24.469-24.471c-7.162,0-13.547,3.132-18.021,8.033L295.226,523.532
                        c-21.511,21.545-56.271,35.463-88.553,35.463c-17.036,0-41.119-3.792-59.14-21.836l-56.299-56.3
                        c-37.093-37.093-22.869-111.116,13.631-147.678l267.88-267.851c10.369-10.38,24.174-16.099,38.871-16.099
                        s28.5,5.718,38.871,16.104l47.402,47.363c21.404,21.473,21.404,56.352,0.004,77.753L272.668,415.644
                        c-13.646,13.67-28.435,21.19-41.654,21.19c-9.912,0-19.054-4.126-27.187-12.264c-9.95-9.955-9.95-17.088-9.95-32.714
                        c0-14.664,5.723-28.467,16.108-38.871L406.95,156.041c0,0,5.789-5.375,5.789-16.773c0-13.517-10.959-24.47-24.471-24.47
                        c-7.75,0-14.572,3.672-19.057,9.29L175.135,318.135c-19.679,19.713-30.523,45.896-30.542,73.718
                        c0,26.636,4.083,47.229,24.389,67.559c17.294,17.294,38.518,26.436,61.387,26.431c26.98,0,54.382-12.556,77.15-35.357
                        l225.227-225.187c40.648-40.646,40.648-106.79,0-147.444l-47.406-47.368C465.676,10.825,439.495,0,411.616,0
                        s-54.062,10.825-73.723,30.485L70.024,298.335c-31.054,31.021-49.596,77.059-49.596,123.161c0,37.59,12.771,71.054,35.955,94.214
                        L112.682,572.01z"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div class="info-wrapper" v-show="!tools.attache.show">
              <div class="info">Datei anhängen</div>
            </div>
            <div
              class="toggle-list-wrapper files"
              v-if="tools.attache.show"
              v-click-outside="hideAttacheFile"
            >
              <div
                v-for="(f, index) in files"
                :key="index"
                class="item"
                :class="{ checked: f.selected }"
                :disabled="!isUserHasAccess"
              >
                <img class="logo" :src="getImgUrl('./file-icon.png')" />
                <div class="label">{{ f.name }}</div>
                <div class="check-box" @click="attacheFile(f)">
                  <svg width="26" height="15" class="icon">
                    <rect x="0" y="0" />
                    <g>
                      <g>
                        <rect
                          x="65.38988800054005"
                          y="111.28423827474339"
                          width="61.04743778705597"
                          height="237"
                          transform="matrix(0.027894680951674893,-0.02301867936171278,0.01967084489978093,0.0326421523831461,-4.013084678766421,5.249976641417972) "
                        />
                        <rect
                          x="305.0431614702238"
                          y="-96.1089254879951"
                          width="62.20270872116089"
                          height="558.1124589443208"
                          transform="matrix(0.01917799119807895,0.03304131945959807,-0.028235793207795276,0.022441945551370072,11.382479318709576,-7.922156200173908) "
                        />
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="element" v-if="dataFields.length > 0 && isUserHasAccess">
            <div class="button" @click.stop="toggleDataFields">
              <svg
                width="24px"
                height="24px"
                x="0px"
                y="0px"
                viewBox="0 0 450 600"
                class="data-fields"
              >
                <g>
                  <rect
                    fill
                    stroke-dashoffset
                    fill-rule="nonzero"
                    id="svg_20"
                    x="321.42857360839844"
                    y="328.7261941432953"
                    width="226"
                    height="30"
                    style="color: rgb(0, 0, 0)"
                    class
                  />
                  <rect
                    fill
                    stroke-dashoffset
                    fill-rule="nonzero"
                    x="322.1230182647705"
                    y="327.4761941432953"
                    width="226"
                    height="30"
                    style="color: rgb(0, 0, 0)"
                    class
                    id="svg_29"
                    transform="rotate(89.70001220703125 435.1231689453125,342.4761657714844) "
                  />
                  <rect
                    fill
                    stroke-dashoffset
                    fill-rule="nonzero"
                    x="-0.17856436967849731"
                    y="233.25000143051147"
                    width="351.9325393145858"
                    height="30"
                    style="color: rgb(0, 0, 0)"
                    class
                    id="svg_28"
                  />
                  <rect
                    fill
                    stroke-dashoffset
                    fill-rule="nonzero"
                    x="0"
                    y="0.75"
                    width="403.32143771648407"
                    height="30"
                    style="color: rgb(0, 0, 0)"
                    class
                    id="svg_32"
                  />
                  <rect
                    fill
                    stroke-dashoffset
                    fill-rule="nonzero"
                    x="0"
                    y="117.03968334197998"
                    width="404.2142987717938"
                    height="30"
                    style="color: rgb(0, 0, 0)"
                    class
                    id="svg_30"
                  />
                </g>
              </svg>
            </div>
            <div class="info-wrapper" v-show="!tools.addDataField.show">
              <div class="info">Daten einfügen</div>
            </div>
            <div
              class="toggle-list-wrapper data-fields"
              v-if="tools.addDataField.show"
              v-click-outside="hideDataFields"
              @scroll.passive="showScrollbar"
            >
              <div class="search">
                <span class="search-icon"></span>
                <input
                  name="search"
                  v-model="dataFieldFilter"
                  placeholder="Suchbegriff"
                />
              </div>
              <div class="data-fields-content fancy-scroll">
                <div
                  v-for="(f, index) in filteredDataFields"
                  :key="index"
                  class="item"
                  @click="insertInputData(f.name)"
                >
                  <div class="label">{{ f.label }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="element" v-if="isUserHasAccess">
            <div class="button" @click.stop="toggleWorkflow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 35 35"
                x="0px"
                y="0px"
                width="24px"
                height="24px"
                class="data-fields"
                style="margin-top: 3"
                stroke-width="0"
              >
                <g transform="matrix(1,0,0,1,-74,-111)">
                  <path
                    d="M92.241,120.689L87.839,122.793C86.664,121.106 84.71,120 82.5,120C78.913,120 76,122.913 76,126.5C76,130.087 78.913,133 82.5,133C84.372,133 86.061,132.207 87.247,130.938L92.129,133.757C92.045,134.158 92,134.574 92,135C92,138.311 94.689,141 98,141C101.311,141 104,138.311 104,135C104,131.689 101.311,129 98,129C95.832,129 93.93,130.153 92.876,131.879L88.376,129.281C88.776,128.438 89,127.495 89,126.5C89,125.836 88.9,125.195 88.715,124.591L93.118,122.486C94.206,124.008 95.988,125 98,125C101.311,125 104,122.311 104,119C104,115.689 101.311,113 98,113C94.689,113 92,115.689 92,119C92,119.586 92.084,120.153 92.241,120.689ZM98,131C100.208,131 102,132.792 102,135C102,137.208 100.208,139 98,139C95.792,139 94,137.208 94,135C94,132.792 95.792,131 98,131ZM82.5,122C84.984,122 87,124.016 87,126.5C87,128.984 84.984,131 82.5,131C80.016,131 78,128.984 78,126.5C78,124.016 80.016,122 82.5,122ZM98,115C100.208,115 102,116.792 102,119C102,121.208 100.208,123 98,123C95.792,123 94,121.208 94,119C94,116.792 95.792,115 98,115Z"
                  />
                </g>
              </svg>
            </div>
            <div class="info-wrapper" v-show="!tools.addWorkflow.show">
              <div class="info">Workflow teilen</div>
            </div>
            <div
              class="toggle-list-wrapper data-fields"
              v-if="tools.addWorkflow.show"
              v-click-outside="hideWorkflow"
              @scroll.passive="showScrollbar"
            >
              <div class="search">
                <span class="search-icon"></span>
                <input
                  name="search"
                  v-model="workflowfilter"
                  placeholder="Suchbegriff"
                />
              </div>
              <div class="data-fields-content fancy-scroll">
                <div
                  v-for="(f, index) in filteredWorkflow"
                  :key="index + f.id"
                  class="item"
                  @click="getWorkFlowData(f, 'add')"
                >
                  <div class="label">{{ f.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab">
          <div class="e-mail-params">
            <div class="form-group">
              <div class="label">An:</div>
              <b-form-tags
                ref="receiver"
                input-id="tags-basic-email"
                v-model="task.props.receiver"
                separator=" ,;"
                remove-on-delete
                placeholder=""
                name="emails"
                required
                :tag-validator="emailValidator"
                @blur="onEmailInputBlur($event, 'receiver')"
                @focus="activeInput = 'receiver'"
                no-outer-focus
                :autofocus="false"
                :disabled="!isUserHasAccess"
              >
              </b-form-tags>
              <b-button
                class="email-collapse-btn"
                @click="toggleExtraEmailFields"
              >
                <b-icon icon="chevron-down"></b-icon>
              </b-button>
            </div>
            <div class="form-group">
              <div class="label">CC:</div>
              <b-form-tags
                ref="cc"
                input-id="tags-basic-email-cc"
                v-model="task.props.cc"
                separator=" ,;"
                remove-on-delete
                placeholder=""
                name="emails-cc"
                required
                :tag-validator="emailValidator"
                @blur="onEmailInputBlur($event, 'cc')"
                @focus="activeInput = 'cc'"
                no-outer-focus
                :autofocus="false"
                :disabled="!isUserHasAccess"
              >
              </b-form-tags>
            </div>
            <b-collapse id="collapse-from" v-model="isShowExtraEmailFields">
              <div class="form-group">
                <div class="label">Von:</div>
                <b-form-tags
                  ref="from"
                  input-id="tags-basic-email-from"
                  v-model="task.props.from"
                  separator=" ,;"
                  remove-on-delete
                  placeholder=""
                  name="emails-from"
                  required
                  :tag-validator="emailValidator"
                  @blur="onEmailInputBlur($event, 'from')"
                  @focus="activeInput = 'from'"
                  no-outer-focus
                  :autofocus="false"
                  :disabled="!isUserHasAccess"
                >
                </b-form-tags>
              </div>
            </b-collapse>
            <b-collapse id="collapse-bcc" v-model="isShowExtraEmailFields">
              <div class="form-group">
                <div class="label">BCC:</div>
                <b-form-tags
                  ref="bcc"
                  input-id="tags-basic-email-bcc"
                  v-model="task.props.bcc"
                  separator=" ,;"
                  remove-on-delete
                  placeholder=""
                  name="emails-bcc"
                  required
                  :tag-validator="emailValidator"
                  @blur="onEmailInputBlur($event, 'bcc')"
                  @focus="activeInput = 'bcc'"
                  no-outer-focus
                  :autofocus="false"
                  :disabled="!isUserHasAccess"
                >
                </b-form-tags>
              </div>
            </b-collapse>
            <b-collapse id="collapse-replyTo" v-model="isShowExtraEmailFields">
              <div class="form-group">
                <div class="label">Antwort an:</div>
                <input
                  v-model="task.props.replyTo"
                  @focus="activeInput = 'replyTo'"
                  ref="replyTo"
                  :disabled="!isUserHasAccess"
                />
              </div>
            </b-collapse>

            <div class="form-group">
              <div class="label">Betreff:</div>
              <input
                v-model="task.props.subject"
                @focus="activeInput = 'subject'"
                ref="subject"
                :disabled="!isUserHasAccess"
              />
            </div>
          </div>
          <div
            class="e-mail-content-wrapper"
            :class="{
              'e-mail-content-wrapper-expanded': isShowExtraEmailFields,
              'file-attachment-visible':
                task?.props?.attachment && task.props.attachment.length > 0,
            }"
          >
            <rich-text
              ref="rich-text"
              :content="task.props.message"
              class="rich-text"
              :style="{
                'min-height': textareaHeight,
              }"
              @focus="activeInput = 'rich-text'"
            >
            </rich-text>
            <div
              v-if="signatureHTML"
              v-html="signatureHTML"
              id="signatureHTML"
            ></div>
          </div>
          <div class="file-attachment" v-if="task?.props?.attachment?.length">
            <div
              v-for="(f, index) in task.props.attachment"
              :key="index"
              class="item"
            >
              <div class="attachment-item">
                <div class="attach-image">
                  <div
                    class="btn-close"
                    v-if="isUserHasAccess"
                    @click="removeAttachment(f.name)"
                  ></div>
                  <img class="logo" v-bind:src="getImgUrl('./file-icon.png')" />
                </div>
                <div class="label">
                  {{ f.hasOwnProperty('label') && f.label ? f.label : f.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <AddWorkFlowModal
        v-if="workFlowModal.visible"
        @closeModal="closeWorkFlowModal"
        @onAddModalSave="onAddModalSave"
        :workFlowModal="workFlowModal"
      />
    </div>
  </div>
</template>

<script>
import RichText from '../widgets/RichText.vue';
import button from '!raw-loader!../../assets/files/html-button-for-email.txt';
import { getWorkFlowById } from '../../services/workflow.service';
import AddWorkFlowModal from '../modals/AddWorkFlowModal.vue';
import {
  getApiEndpointVersion,
  getInputPlaceholderList,
  debouncer,
  LATEST_FLOW_RUNNER_VERSION,
} from '@/utils/helpers.js';
export default {
  name: 'Email',
  data() {
    return {
      isShowExtraEmailFields: false,

      signatureHTML: null,
      dataFieldFilter: null,
      actionFilter: null,
      workflowfilter: null,
      activeInput: null,
      actions: [
        {
          name: 'Gutschrift beantragen',
          html: button,
        },
        {
          name: 'Gutschrift Bestätigen/Ablehnen',
          html: button,
        },
      ],
      tools: {
        attache: {
          show: false,
        },
        addDataField: {
          show: false,
        },
        addAction: {
          show: false,
        },
        addWorkflow: {
          show: false,
        },
      },
      workFlowModal: {
        visible: false,
        loading: false,
        selectedFlow: {},
        elements: [],
        mode: null,
        linkName: '',
        editParentID: null,
        editObjectvalues: {},
      },
    };
  },
  props: {
    task: Object,
    input: Array,
    isUserHasAccess: { type: Boolean, default: true },
    flowRunnerEndpoint: {
      type: String,
    },
  },
  mounted() {
    this.addClickToEditBtn();
    const qlEditor =
      this.$refs['rich-text']?.$el?.querySelectorAll('.ql-editor')[0];
    if (qlEditor) {
      qlEditor.addEventListener('scroll', this.showScrollbar);
    }
  },
  created() {
    this.addEmailInArray(this.task.props.receiver, 'receiver');
    this.addEmailInArray(this.task.props.cc, 'cc');
    this.addEmailInArray(this.task.props.bcc, 'bcc');
    this.addEmailInArray(this.task.props.from, 'from');
  },
  destroyed() {
    const qlEditor =
      this.$refs['rich-text']?.$el?.querySelectorAll('.ql-editor')[0];
    if (qlEditor) {
      qlEditor.removeEventListener('scroll', this.showScrollbar);
    }
  },
  methods: {
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    addClickToEditBtn() {
      const vm = this;
      const editBtns = document.getElementsByClassName(
        'rich-text-email-button-edit-icon'
      );

      if (editBtns && editBtns.length > 0) {
        editBtns.forEach((btn) => {
          btn.addEventListener('click', function (e) {
            const flowID = e.target.getAttribute('data-flow-id');
            const flowLinkName = e.target.getAttribute('data-flow-link-name');
            const parentid = e.target.getAttribute('data-parent-id');
            const dataUrl = e.target.getAttribute('data-url');

            // Make data obj using params
            const paramString = dataUrl.split('?') && dataUrl.split('?')[1];
            const paramsArr = paramString.split('&');
            const obj = {};
            for (let i = 0; i < paramsArr.length; i++) {
              let pair = paramsArr[i].split('=');

              if (pair[0] !== 'id') {
                obj[pair[0]] = pair[1];
              }
            }
            vm.workFlowModal.linkName = flowLinkName;
            vm.workFlowModal.editParentID = parentid;
            vm.workFlowModal.editObjectvalues = obj;

            vm.getWorkFlowData({ id: flowID }, 'edit');
          });
        });
      }
    },
    async getWorkFlowData(data, mode) {
      this.workFlowModal.visible = true;
      this.workFlowModal.loading = true;
      this.workFlowModal.mode = mode;

      try {
        const response = await getWorkFlowById(data.id);
        if (response && response.data && response.status === 200) {
          if (response.data.tasks.length > 0) {
            this.workFlowModal.selectedFlow = data;
            const flowOutput =
              response.data.tasks[0].props.formTrigger.elements;
            this.workFlowModal.elements = flowOutput;
            this.workFlowModal.loading = false;
          } else {
            this.showToaster('Kein Schema gefunden', 'Fehler', 'danger');
            throw new Error('no schema provided');
          }
        }
      } catch (error) {
        console.log({ error });
        this.closeWorkFlowModal();
      }
    },
    onAddModalSave(data) {
      if (this.workFlowModal.mode === 'add') {
        this.task.props.message += '<br /> <br />' + data + '<br /> <br />';
      } else {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.task.props.message;

        const paragraphToRemove = tempDiv.querySelector(
          `#${this.workFlowModal.editParentID}`
        );

        if (paragraphToRemove) {
          const newParagraphwrapper = document.createElement('div');
          newParagraphwrapper.innerHTML = data;

          const newParagraphNode = newParagraphwrapper.firstElementChild;
          paragraphToRemove.parentNode.insertBefore(
            newParagraphNode,
            paragraphToRemove.nextSibling
          );
          paragraphToRemove.parentNode.removeChild(paragraphToRemove);
        }

        const updatedContent = tempDiv.innerHTML;
        this.task.props.message = updatedContent;
      }

      this.closeWorkFlowModal();

      setTimeout(() => {
        this.addClickToEditBtn();
      }, 100);
    },
    closeWorkFlowModal() {
      this.workFlowModal.visible = false;
      this.workFlowModal.selectedFlow = {};
      this.workFlowModal.elements = [];
      this.workFlowModal.mode = null;
      this.workFlowModal.linkName = '';
      this.workFlowModal.editParentID = null;
      this.workFlowModal.editObjectvalues = {};
    },
    close: function () {
      this.task.props.message = this.$refs['rich-text'].richContent;
      this.task.props = {
        ...this.task.props,
        bcc: this.task.props?.bcc?.join(', ') || '',
        cc: this.task.props?.cc?.join(', ') || '',
        receiver: this.task.props?.receiver?.join(', ') || '',
      };
      this.$set(this.task, 'output', this.task.input);
      this.fixLinks();
      this.$emit('close');
    },
    getMessage: function () {
      if (this.task.props.message) return this.task.props.message;
      else return '<br>';
    },
    getImgUrl: function (img) {
      var images = require.context('../../assets/img/', false, /\.png$/);
      return images(img);
    },
    showAttacheFile: function () {
      this.tools.attache.show = true;
    },
    hideAttacheFile: function () {
      this.tools.attache.show = false;
    },
    toggleAttacheFile: function () {
      this.tools.attache.show = !this.tools.attache.show;
      this.hideDataFields();
      this.hideActions();
      this.hideWorkflow();
    },
    hideDataFields: function () {
      this.tools.addDataField.show = false;
    },
    toggleDataFields: function () {
      this.tools.addDataField.show = !this.tools.addDataField.show;
      this.hideAttacheFile();
      this.hideActions();
      this.hideWorkflow();
    },
    toggleWorkflow: function () {
      this.tools.addWorkflow.show = !this.tools.addWorkflow.show;
      this.hideAttacheFile();
      this.hideActions();
      this.hideDataFields();
    },
    hideWorkflow: function () {
      this.tools.addWorkflow.show = false;
    },
    hideActions: function () {
      this.tools.addAction.show = false;
    },
    toggleActions: function () {
      this.tools.addAction.show = !this.tools.addAction.show;
      this.hideDataFields();
      this.hideAttacheFile();
    },
    insertInputData: function (inputData) {
      if (this.activeInput == 'rich-text' || !this.activeInput)
        this.insertText(inputData);
      else {
        let el = this.$refs[this.activeInput];
        let value = this.concatStrAtPosition(
          el.selectionStart,
          el.value,
          inputData
        );
        switch (this.activeInput) {
          case 'receiver':
            if (!this.task.props.receiver.includes(`{${inputData}}`)) {
              this.task.props.receiver.push(`{${inputData}}`);
            } else {
              this.showDuplicateEmailError();
            }
            break;
          case 'cc':
            if (!this.task.props.cc.includes(`{${inputData}}`)) {
              this.task.props.cc.push(`{${inputData}}`);
            } else {
              this.showDuplicateEmailError();
            }
            break;
          case 'bcc':
            if (!this.task.props.bcc.includes(`{${inputData}}`)) {
              this.task.props.bcc.push(`{${inputData}}`);
            } else {
              this.showDuplicateEmailError();
            }
            break;
          case 'from':
            this.task.props.from = value;
            break;
          case 'replyTo':
            this.task.props.replyTo = value;
            break;
          case 'subject':
            this.task.props.subject = value;
            break;
        }
      }
    },
    concatStrAtPosition: function (position, content, input) {
      return (
        content.slice(0, position) + '{' + input + '}' + content.slice(position)
      );
    },
    insertText: function (content) {
      let q = this.$refs['rich-text'].$refs['contant-editor'].quill;
      var selection = q.getSelection(true);
      var insertText = '{' + content + '}';
      q.insertText(selection.index, insertText);
    },
    insertHTML: function (content) {
      let oldContent = this.$refs['rich-text'].richContent;
      this.$refs['rich-text'].richContent = oldContent + content;
    },
    isAttached: function (file) {
      return (
        this.task.props.attachment.filter((f) => f.name == file.name).length > 0
      );
    },
    addAttachment: function (file) {
      this.task.props.attachment.push({ name: file.name, label: file.label });
    },
    removeAttachment(name) {
      if (!this.isUserHasAccess) return;
      this.task.props.attachment = this.task.props.attachment.filter(
        (f) => f.name != name
      );
    },
    attacheFile: function (file) {
      if (!this.isUserHasAccess) return;
      if (file.selected) this.removeAttachment(file.name);
      else this.addAttachment(file);
      this.showAttacheFile();
    },
    toggleExtraEmailFields() {
      this.isShowExtraEmailFields = !this.isShowExtraEmailFields;
    },
    fixLinks() {
      const message = this.task.props.message.replace(
        /href="(https:\/\/|www\.)/g,
        (match, capture) => {
          if (capture === 'www.') {
            return 'href="//';
          } else {
            return match;
          }
        }
      );
      this.task.props.message = message;
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
    emailValidator(tag) {
      if (tag[0] === '{' && tag[tag.length - 1] === '}') {
        return true;
      }
      const pattern = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
      return pattern.test(tag);
    },
    onEmailInputBlur(e, ref) {
      if (this.emailValidator(e.target.value)) {
        this.$refs[ref].addTag();
      } else {
        e.target.value = '';
        this.$refs[ref].newTag = '';
      }
    },
    addEmailInArray(email, type) {
      const emails = typeof email === 'object' ? email : email.split(', ');
      if (emails.length) {
        this.task.props[type] = emails;
      }
    },
    showDuplicateEmailError(email) {
      this.showToaster(
        `Die von Ihnen eingegebene E-Mail-Adresse
wird bereits verwendet.`,
        'Fehlerhaft !',
        'danger'
      );
    },
  },
  computed: {
    dataFields() {
      const fieldsToFiltered = ['file', 'filenew', 'model', 'dataframe'];
      const apiVersion =
        getApiEndpointVersion(this.flowRunnerEndpoint) ||
        LATEST_FLOW_RUNNER_VERSION;
      return getInputPlaceholderList(
        this.task.input,
        apiVersion,
        fieldsToFiltered,
        true
      );
    },
    filteredDataFields() {
      return this.dataFields.filter((f) => {
        if (this.dataFieldFilter)
          return (
            f.label.toLowerCase().indexOf(this.dataFieldFilter.toLowerCase()) >
            -1
          );
        else return this.dataFields;
      });
    },
    filteredActions() {
      return this.actions.filter((a) => {
        if (this.actionFilter)
          return (
            a.name.toLowerCase().indexOf(this.actionFilter.toLowerCase()) > -1
          );
        else return this.actions;
      });
    },
    getWorkFlows() {
      const workflows = this.$store.getters.getAllFlows;
      return [...workflows].filter((el) => el.type === 'app');
    },
    filteredWorkflow() {
      if (this.workflowfilter) {
        return [...this.getWorkFlows].filter(
          (el) =>
            el.name.toLowerCase().indexOf(this.workflowfilter.toLowerCase()) >
            -1
        );
      } else return this.getWorkFlows;
    },
    files() {
      let files = [];
      this.task.input.forEach((e) => {
        if (e.type == 'file' || e.type == 'filenew')
          files.push({
            name: e.name,
            selected: this.isAttached(e),
          });
      });
      return files;
    },
    textareaHeight() {
      if (this.signatureHTML && this.signatureHTML.length > 0) {
        return '250px';
      } else return '100%';
    },
    toolsTop() {
      if (this.signatureHTML && this.signatureHTML.length > 0) {
        return '-90%';
      } else return '-84%';
    },
    dataFieldsNames() {
      return this.dataFields.map((field) => field.name);
    },
  },

  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind: function (el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
  components: {
    RichText,
    AddWorkFlowModal,
  },
};
</script>

<style scoped>
.email-task-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

[disabled] {
  opacity: 0.5;
  cursor: not-allowed !important;
}
.content {
  background-color: #fff;
  width: 100%;
  height: calc(100% - 36px - 30px);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  margin-top: 35px;
}

.email-task-wrapper .content .tools {
  position: absolute !important;
  top: 40% !important;
  right: 36px !important;
}

.tab {
  text-align: left;
  height: 100%;
  box-sizing: border-box;
  position: relative;
}

.e-mail-content-wrapper {
  height: calc(100% - 152px);
  position: relative;
}

.e-mail-content-wrapper.file-attachment-visible {
  height: calc(100% - 260px) !important;
}

.e-mail-content-wrapper.e-mail-content-wrapper-expanded {
  height: calc(100% - 315px);
}

.e-mail-content-wrapper.e-mail-content-wrapper-expanded.file-attachment-visible {
  height: calc(100% - 406px) !important;
}

.e-mail-content-wrapper #signatureHTML {
  padding-bottom: 4%;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

h1 {
  padding-top: 50px;
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h3 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

input {
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 200px;
  width: 100%;
  overflow: scroll;
}

button {
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
}

button.default {
  color: #464d5d;
  background: #fff;
}

.input-group {
  width: 100%;
}

.imput-group > input {
  width: 70%;
}

.input-group > button {
  min-width: 0;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  background: #6bbc7c;
  border: 1px solid #5ab36c;
  margin-bottom: 0;
  border-radius: 0 3px 3px 0;
}

button.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
  left: 3px;
  position: relative;
  top: -153px;
  left: -18px;
}

ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin: 0 18px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/
.tabsLabels .url {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -893px -1109px;
}

.tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .mscons {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -828px -1175px;
}

.tabsLabels .system {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -137px -1178px;
}

p {
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: #7e8890;
  margin: 25px 0px 25px 0px;
}

.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.pull-right.default {
  margin-top: 0;
}

.e-mail-params {
  height: max-content;
}

button {
  margin-top: 20px;
}

.form-group {
  width: 100%;
  height: 50px;
  display: flex;
  margin-top: 0px;
  padding-top: 1px;
  padding-bottom: 1px;
  border-bottom: 1px;
  border-bottom-style: solid;
  border-bottom-color: #dee0e4;
  margin-bottom: 0px;
}

.form-group .label {
  margin-top: 20px;
  text-transform: none;
  text-wrap: nowrap;
}

.form-group input {
  width: 100%;
  border: 0;
  padding-bottom: 14px;
  padding-top: 18px;
  cursor: text;
  background: none;
}

input:focus {
  outline: none;
}

.element {
  margin-bottom: 16px;
}

:root {
  --color-pink: #f36;
  --color-pink-darker: #e81e61;
  --color-blue-lighter: #f5fbff;
  --color-blue: #276ee5;
  --color-blue-darker: #1f53d5;
  --color-green-lighter: #f2fbfa;
  --color-green: #09baa6;
  --color-green-darker: #00a08e;
  --color-yellow-lighter: #fffbf4;
  --color-yellow: #ffb631;
  --color-yellow-darker: #e8a01e;
  --color-red-lighter: #fdf3f5;
  --color-red: #e01e3d;
  --color-red-darker: #c60d2b;
  --color-ink-lightest: #9599a2;
  --color-ink-lighter: #6e7077;
  --color-ink: #22252b;
  --color-ink-darker: #17191d;
  --color-gray-lightest: #f8f8fa;
  --color-gray-lighter: #ebecee;
  --color-gray: #dee0e4;
  --color-gray-darker: #c7cad1;
  --color-black-lighter: #182237;
  --color-black: #15181f;
  --color-white: #fff;
  --elevation-low: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.12);
  --elevation-medium: 0 0 0 1px rgba(0, 0, 0, 0.05),
    0 5px 10px rgba(0, 0, 0, 0.15);
  --elevation-high: 0 0 0 1px rgba(0, 0, 0, 0.05),
    0 10px 20px rgba(0, 0, 0, 0.15);
  --rounded: 4px;
  --circled: 50%;
  --pilled: 64px;
}

.pretty {
  line-height: 36px;
}

.logo {
  width: 35px;
  margin-top: 0;
}

.check-box {
  border-style: solid;
  height: 16px;
  width: 16px;
  position: absolute;
  top: 8px;
  left: 8px;
  border-width: 1px;
  border-color: var(--color-black);
  background-color: #ffff;
  transition: all 0.3s ease-out;
  border-radius: 50%;
}

.check-box .icon {
  fill: #ffff;
  zoom: 0.6;
  padding-top: 0;
  padding-left: 3px;
}

.item.checked .check-box {
  background-color: var(--color-black);
}

.search {
  width: 200px;
  padding: 5px 0 26px 0;
  height: 21px;
  margin-left: 12px;
  border-bottom: solid 1px #bdc3c7;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}

.search-icon {
  background-image: url(data:image/png;base64,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);
  background-size: 23px;
  overflow: hidden;
  display: block;
  width: 24px;
  height: 21px;
  float: left;
  background-position: 0px 0px;
}

.search input {
  border: 0;
  width: 85%;
  margin-left: 5px;
  height: 20px;
  padding: 4px 4px !important;
  cursor: initial;
  padding-top: 11px;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  font-weight: 300;
  margin-bottom: 0;
  box-sizing: border-box;
}

.file-attachment {
  width: 100%;
  padding: 10px 15px;
  display: flex;
  position: absolute;
  bottom: 0;
  left: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  border-top: 1px solid #dee0e4;
}

.file-attachment .item {
  width: 50px;
  margin-right: 10px;
  text-align: center;
  margin-top: 10px;
  flex-shrink: 0;
}

.file-attachment .attachment-item .attach-image {
  position: relative;
  width: fit-content;
  margin: 0 auto;
}

.file-attachment .attachment-item .label {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: center;
}

.file-attachment .attachment-item .btn-close {
  position: absolute;
  top: -4px;
  right: -14px;
  display: none;
}

.file-attachment .attachment-item:hover .btn-close {
  display: block;
}

.attachment .item {
  cursor: auto;
  padding: 8px;
  width: 75px;
  text-align: center;
  display: inline-block;
  vertical-align: top;
  box-sizing: border-box;
}

.attachment .item .label {
  font-size: 12px;
  text-transform: none;
  padding: 0;
  margin: 0;
  margin-top: 11px;
  height: 44px;
  color: #596377;
}

.toggle-list-wrapper.data-fields .item .label {
  line-height: 41px;
}

#app.rich-text {
  height: 100%;
  width: 100%;
}

.email-task-wrapper ::v-deep .ql-toolbar.ql-snow {
  pointer-events: all;
  width: fit-content;
  flex-direction: row;
  flex-shrink: 0;
  box-shadow: var(--elevation-medium);
  background: #fff;
  z-index: 100;
  margin-left: auto;
  margin-right: auto;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica,
    Arial, sans-serif, Inv Maison Neue, Apple Color Emoji, Segoe UI Emoji,
    Segoe UI Symbol;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  z-index: 3;
  margin-bottom: 0px;
  position: absolute;
  border-radius: 6px;
  height: 55px;
  margin: 0px;
  top: -62px;
}

::v-deep .ql-container.ql-snow {
  border: none;
}

::v-deep .ql-toolbar.ql-snow .ql-formats {
  border: none;
  width: 132px;
  text-align: center;
  position: relative;
  padding-left: 8px;
  height: 40px;
  padding-top: 7px;
}

::v-deep .modal.task .e-mail-content-wrapper .tools {
  position: absolute;
  top: 50% !important;
  right: 10px;
  transform: translateY(-50%);
}

::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
::v-deep .toast:not(.show) {
  display: block;
}

::v-deep .email-collapse-btn {
  width: 30px;
  height: 20px;
  margin: 18px 0;
  padding: 0;
  background: transparent !important;
  color: #9f9f9f !important;
  border: none !important;
}

::v-deep .email-task-wrapper .email-collapse-btn:hover {
  color: #5d5a5a;
}

.email-task-wrapper .content {
  overflow: hidden;
}
.email-task-wrapper ::v-deep .ql-editor {
  margin-top: 20px;
  padding-top: 0px;
  padding: 0;
}

::v-deep .ql-editor::-webkit-scrollbar {
  width: 4px;
}

::v-deep .ql-editor::-webkit-scrollbar-track {
  border-radius: 7px;
  background-color: transparent;
  border: 1px solid transparent;
}

::v-deep .ql-editor::-webkit-scrollbar-thumb {
  border-radius: 7px;
  background-color: #565656;
}
@media screen and (max-width: 1366px) {
  ::v-deep .ql-editor::-webkit-scrollbar-thumb {
    display: none;
  }
}

::v-deep .ql-editor.show-scrollbar::-webkit-scrollbar-thumb {
  display: block;
}
.email-task-wrapper .data-fields-content {
  overflow-x: hidden;
  overflow-y: auto;
  height: 190px;
}
.email-task-wrapper ::v-deep .b-form-tags {
  border: none !important;
}

.email-task-wrapper .b-form-tags {
  max-height: 60px;
  overflow: auto;
}
.email-task-wrapper .b-form-tags.focus,
.email-task-wrapper.b-form-tags:focus {
  border: 2px solid #000;
  box-shadow: none;
}
.email-task-wrapper ::v-deep .b-form-tags .b-form-tags-list button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}
.email-task-wrapper ::v-deep .b-form-tags.form-control {
  background-color: transparent;
}
.email-task-wrapper ::v-deep .b-form-tags .b-form-tags-button {
  display: none;
}
.email-task-wrapper::v-deep .b-form-tags .b-form-tags-list .close {
  font-weight: 700;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
  line-height: 1.5;
}
.email-task-wrapper ::v-deep .b-form-tags .b-form-tags-list .badge-secondary {
  color: #fff;
  background-color: #333343;
  --bs-badge-padding-y: 1px;
}
.email-task-wrapper::v-deep .b-form-tags .b-form-tags-list .b-form-tag {
  margin-top: 0.75rem;
}
.email-task-wrapper::v-deep .b-form-tags .b-form-tags-input {
  padding-top: 13px !important;
}
.email-task-wrapper::v-deep .b-form-tags .invalid-feedback {
  display: none !important;
}

.email-task-wrapper::v-deep .quillWrapper {
  height: calc(100% - 75px);
}
</style>
